import { render, staticRenderFns } from "./InBlockPage.vue?vue&type=template&id=37c97c7f&"
import script from "./InBlockPage.vue?vue&type=script&lang=js&"
export * from "./InBlockPage.vue?vue&type=script&lang=js&"
import style0 from "./InBlockPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports